/**
 * @fileoverview The browser-chrome frame a product screenshot sits in on the
 * marketing site.
 *
 * Extracted because it was already written twice, byte for byte — once inline
 * in LandingPage's hero and once as a local component in FeaturePage — and the
 * organization overview page would have made three. A frame that drifts between
 * pages reads as two different products.
 *
 * The chrome is deliberately blank: no URL, no tab title, no favicon. It says
 * "this is the real application" without pretending to be a specific browser on
 * a specific machine, and it never has to be re-drawn when a URL changes.
 */

const BrowserFrame = ({ children, className = "" }) => (
  <div
    className={`overflow-hidden rounded-2xl border border-white/8 bg-[#0f0f11] shadow-2xl ${className}`} /* brand-lint-ignore: marketing chrome, matches the two frames it replaces */
    style={{ transform: "rotateX(2deg)", transformOrigin: "center bottom" }}
  >
    {/* The chrome's own greys stay raw white-alpha rather than Studio Quiet
        tokens, and are the same values the two frames this replaces used. They
        are not a Hans surface: this is a drawing of somebody else's browser,
        sitting on a public page that is pinned dark and never themes, so a
        token that resolves differently in light would repaint a window frame
        that has no light mode. */}
    <div className="flex items-center gap-1.5 border-b border-white/5 px-4 py-3"> {/* brand-lint-ignore: browser chrome, see above */}
      <div className="h-2.5 w-2.5 rounded-full bg-white/10" /> {/* brand-lint-ignore: browser chrome */}
      <div className="h-2.5 w-2.5 rounded-full bg-white/10" /> {/* brand-lint-ignore: browser chrome */}
      <div className="h-2.5 w-2.5 rounded-full bg-white/10" /> {/* brand-lint-ignore: browser chrome */}
      <div className="mx-3 flex-1">
        <div className="h-5 max-w-[200px] mx-auto rounded-md bg-white/5" /> {/* brand-lint-ignore: browser chrome */}
      </div>
    </div>
    {children}
  </div>
);

export default BrowserFrame;
